var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM4.70711 9.53548C4.31658 9.14495 4.31658 8.51179 4.70711 8.12126C5.09763 7.73074 5.7308 7.73074 6.12132 8.12126L9.65689 11.6568L14.6066 6.70711C14.9971 6.31658 15.6303 6.31658 16.0208 6.70711C16.4114 7.09763 16.4114 7.7308 16.0208 8.12132L10.364 13.7782C9.97345 14.1687 9.34028 14.1687 8.94976 13.7782C8.94783 13.7762 8.9459 13.7743 8.94399 13.7724L4.70711 9.53548Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnOk);
export default __webpack_public_path__ + "static/media/btn_ok.a32ba5d6ca2b51fa37d62723f2be3383.svg";
export { ForwardRef as ReactComponent };